export enum SoilComposition {
  Unknown = 'UNKNOWN',
  Porous = 'POROUS',
  NonPorous = 'NON_POROUS',
}
